<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import TableExpand from "../rds/TableExpand.vue";
var tableDataVue = {};
export default {
  name: "TableRelationalDatabaseServiceResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(TableExpand, {
              props: {
                row: params.row
              }
            });
          }
        },
        {
          title: this.$t("RAM.ALI.database.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.ALI.database.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.ALI.database.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.ALI.database.name"),
          key: "name"
        },
        {
          title: this.$t("RAM.ALI.database.endpoint"),
          key: "endpoint"
        },
        {
          title: this.$t("RAM.ALI.database.engine"),
          key: "engine"
        },
        {
          title: this.$t("RAM.ALI.database.instanceType"),
          key: "type"
        },

        {
          title: this.$t("RAM.ALI.database.storageSize"),
          key: "allocatedStorage"
        },
        {
          title: this.$t("RAM.ALI.database.iops"),
          key: "iops"
        }
      ],
      tableData: []
    };
  },
  beforeCreate: function() {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("accountName", function(val) {
      tableDataVue.accountName = val;
    });
    eventBus.$on("nameSearchKey", function(val) {
      tableDataVue.nameSearchKey = val;
    });
    eventBus.$on("engineSearchKey", function(val) {
      tableDataVue.engineSearchKey = val;
    });
    eventBus.$on("typeSearchKey", function(val) {
      tableDataVue.typeSearchKey = val;
    });
    eventBus.$on("state", function(val) {
      tableDataVue.state = val;
    });
    eventBus.$on("companyId", function(val) {
      tableDataVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      this.$api.resourceManagement
        .selectAliyunDatabaseByPage({
          pageNum: this.current,
          pageSize: this.pageSize,
          accountName: tableDataVue.accountName,
          dbInstanceName: tableDataVue.nameSearchKey,
          engineType: tableDataVue.engineSearchKey,
          dbInstanceType: tableDataVue.typeSearchKey,
          companyId: tableDataVue.companyId,
          state: tableDataVue.state
        })
        .then(res => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("companyId");
      eventBus.$off("accountName");
      eventBus.$off("nameSearchKey");
      eventBus.$off("engineSearchKey");
      eventBus.$off("typeSearchKey");
      eventBus.$off("state");
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/rds/TableRelationalDatabaseServiceResource.vue